'use client';

import * as React from 'react';

import { Dashboard } from '@/shared/i18n';
import { ContentsSection } from '../shared';
import { initialPagination } from '../../utils/pagination';
import { formatDateToCustomString } from '../../utils/date-format';
import { DashboardEventKeys, DashboardEvents } from '../../events';
import { EventBus } from '@/shared/utils';
import { useDashboardStore } from '../../store/dashboard-store';

interface UpComingLivesProps {
  isSubscriber: boolean;
  dict: Dashboard;
  eventBus: EventBus<DashboardEvents>;
}

const UpComingLives: React.FC<UpComingLivesProps> = ({ isSubscriber, dict, eventBus }) => {
  const { upComingLives } = useDashboardStore();
  React.useEffect(() => {
    if (!upComingLives?.data?.data)
      eventBus.emit(DashboardEventKeys.upComingLives.view, initialPagination);
  }, [upComingLives?.data?.data, eventBus]);
  return (
    <ContentsSection
      type="slider"
      title="Live in arrivo"
      fetchMore={(page, pageSize) =>
        eventBus.emit(DashboardEventKeys.upComingLives.view, { page, pageSize })
      }
      pagination={upComingLives?.data?.pagination}
      data={
        upComingLives?.data?.data?.map((el) => ({
          title: el?.title,
          lessonCount: el?.date,
          isCourseStarted: false,
          isLocked: !isSubscriber,
          linkLive: el?.linkLive || null,
          level: el.skillLevel?.name,
          upComingEvent: formatDateToCustomString(el?.date),
          imageSrc: el?.featuredImage?.url || '/assets/images/video-play.svg',
          courseType: 'Masterclass',
          instructors: el?.teacherProfiles?.map((teacher) => ({
            name: teacher?.displayName,
            avatarUrl: teacher?.profilePicture?.url,
          })),
        })) || []
      }
      isLoading={upComingLives?.status.isLoading}
      isError={upComingLives?.status.isError}
      onCardClickCallback={(item) => {
        if (!item?.linkLive) return;
        eventBus.emit(DashboardEventKeys.redirects.to, {
          url: item?.linkLive,
          isExternalPage: true,
        });
      }}
      hasNavigationButtons={
        !!upComingLives?.data?.data?.length && upComingLives?.data?.data?.length > 3
      }
      dict={dict}
      eventBus={undefined}
    />
  );
};
export default UpComingLives;
